// extracted by mini-css-extract-plugin
module.exports = {"resumeIconContainer":"ResumeIcon_resumeIconContainer__34gqJ","resumeIcon":"ResumeIcon_resumeIcon__2kQZg"};